/* ============================================================
   Monark Golf — Global Options Block v8
   File: assets/global-options.js

   CONDITIONAL CHAIN SYSTEM
   ─────────────────────────────────────────────────────────────
   Supports unlimited sequential conditional dropdowns.
   Each option can depend on one or more parent options.
   Until a parent is selected, child shows "Select..." placeholder
   and is disabled. When parent changes, child resets to
   "Select..." and filters its options.

   METAFIELD CONFIG FORMAT:
   {
     "name": "CF Flex",
     "type": "dropdown",
     "placeholder": "Select...",          ← shown until parent selected
     "conditions": {
       "depends_on": "CF Loft",           ← parent option name
       "map": {
         "#3 RH": ["Regular","Stiff"],    ← parent value → allowed child options
         "#4 RH": ["Regular","Stiff","X-Stiff"],
         "#5 RH": ["Ladies","Senior","Regular","Stiff","X-Stiff"]
       }
     }
   }

   UPGRADE TOTAL:
   Add "price_cents" to any option value. Upgrade Total and
   Subtotal update live as selections change.
   ─────────────────────────────────────────────────────────────
*/

(function () {
  'use strict';

  /* 
  assets/upgrade-variants.js 
  window.UPGRADE_VARIANTS = {};
  */

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function qs(s, c)  { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.from((c || document).querySelectorAll(s)); }
  function ea(s) { return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;'); }
  function et(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  function safeJSON(str) {
    if (!str) return null;
    var txt = document.createElement('textarea');
    txt.innerHTML = str;
    var decoded = txt.value;
    try { return JSON.parse(decoded); } catch(e) { /* fall through */ }
    try {
      var fixed = decoded
        .replace(/"=>"/g,  '":"')
        .replace(/"=>/g,   '":')
        .replace(/:true\b/g,  ':true')
        .replace(/:false\b/g, ':false')
        .replace(/:nil\b/g,   ':null')
        .replace(/:([a-zA-Z_][a-zA-Z0-9_]*)=>/g, '"$1":');
      var parsed = JSON.parse(fixed);
      console.warn('[GlobalOptions] Ruby hash format. Fix: set metafield type to JSON.');
      return parsed;
    } catch(e2) {
      console.error('[GlobalOptions] JSON parse error:', e2.message, '\nRaw:', decoded.slice(0,300));
      return null;
    }
  }

  /* ── Find Horizon add-to-cart form ── */
  function findCartForm(wrapper) {
    var el = wrapper.parentElement;
    while (el && el !== document.body) {
      if (el.tagName === 'FORM' && el.dataset.type === 'add-to-cart-form') return el;
      el = el.parentElement;
    }
    var pfc = qs('product-form-component');
    if (pfc) { var f = qs('form[data-type="add-to-cart-form"]', pfc); if (f) return f; }
    return qs('form[data-type="add-to-cart-form"]')
        || qs('form[id^="BuyButtons-ProductForm"]')
        || qs('form[action="/cart/add"]');
  }

  /* ── Resolve merged options ── */
  function resolveOptions(globalOpts, productCfg) {
    if (!Array.isArray(globalOpts) || !Array.isArray(productCfg)) return [];
    var gmap = {};
    globalOpts.forEach(function(g) { if (g.name) gmap[g.name] = g; });

    return productCfg.map(function(cfg) {
      var global = gmap[cfg.name];
      if (!global) { console.warn('[GlobalOptions] "' + cfg.name + '" not in registry.'); return null; }

      var displayType;
      if (cfg.type)                   displayType = cfg.type;
      else if (cfg.primary === false) displayType = 'dropdown';
      else                            displayType = global.type || 'dropdown';

      var overrideMap = {};
      if (Array.isArray(cfg.options)) {
        cfg.options.forEach(function(v) { if (v.label) overrideMap[v.label] = v; });
      }
      var sourceValues = (Array.isArray(cfg.options) && cfg.options.length > 0)
        ? cfg.options : (global.options || []);

      var vals = sourceValues.map(function(src) {
        var gv = (global.options||[]).find(function(g){ return g.label===src.label; })||{};
        var ov = overrideMap[src.label] || {};
        return {
          label       : src.label,
          price_cents : parseInt(ov.price_cents !== undefined ? ov.price_cents : 0, 10),
          sku         : ov.sku  || '',
          qty         : parseInt(ov.qty !== undefined ? ov.qty : 99, 10),
          enabled     : ov.enabled !== false,
          color       : ov.color || gv.color || '',
          image       : ov.image || gv.image || ''
        };
      }).filter(function(v){ return v.label; });

      return {
        name        : cfg.name,
        displayType : displayType,
        placeholder : cfg.placeholder || 'Select...',
        options      : vals
      };
    }).filter(Boolean);
  }

  function getFirstEnabled(vals) {
    for (var i=0; i<vals.length; i++) {
      if (vals[i].enabled && vals[i].qty > 0) return i;
    }
    return -1; /* -1 means no enabled value */
  }

  /* ────────────────────────────────────────────────────────────
     RENDER one option block
     hasParent: true = starts disabled with placeholder
  ──────────────────────────────────────────────────────────── */
  function renderBlock(opt, index, pid, basePrice, hasParent, hasTableOption) {
    var uid         = pid + '-opt' + index;
    var type        = opt.displayType;
    /*var fei         = hasParent ? -1 : getFirstEnabled(opt.options);
    var firstLabel  = (!hasParent && fei >= 0) ? opt.options[fei].label : '';*/
    var fei = -1;
    var firstLabel = '';
    var isDisabled  = hasParent; /* starts locked until parent selected */

    /* ── Label row ── */
    var labelHtml = type !== 'table'
      ? '<div class="go-option-label">'
          + '<span class="go-option-name">' + et(opt.name) + '</span>'
          + (opt.name === 'CF Shaft Length'
              ? '<span class="shaft-info-icon" title="How to Measure the Shaft Length"><i class="fa fa-info-circle"></i></span>'
              : '')
          /*+ '<span class="go-selected-val" id="go-val-' + uid + '">' + et(firstLabel) + '</span>'*/
        + '</div>'
      : '';

    var ctrl = '';

    /* ── DROPDOWN ── */
    if (type === 'dropdown') {
      /*var placeholderOpt = '<option value="" data-label="" disabled'
        + (isDisabled || !firstLabel ? ' selected' : '') + ' hidden>'
        + et(opt.placeholder) + '</option>';*/
      
      var placeholderOpt = '';

      if (!hasTableOption) {
        placeholderOpt =
          '<option value="" data-label="" selected>'
          + et(opt.placeholder || 'Select...')
          + '</option>';  
      }

      var optHtml = opt.options.map(function(v) {
        var p   = v.price_cents || 0;
        var ps  = p > 0 ? ' (+' + money(p) + ')' : '';
        var ss  = (v.enabled && v.qty === 0) ? ' — Out of stock' : '';
        var dis = (!v.enabled || v.qty === 0) ? ' disabled' : '';
        var sk  = v.sku ? ' [' + v.sku + ']' : '';
        return '<option value="' + p + '"'
          + ' data-label="' + ea(v.label) + '"'
          + ' data-image="' + ea(v.image || '') + '"'
          + ' data-sku="'   + ea(v.sku) + '"'
          + ' data-qty="'   + v.qty + '"'
          + ' data-enabled="' + (v.enabled ? '1' : '0') + '"'
          + dis + '>'
          + et(v.label) + sk + ps + ss
          + '</option>';
      }).join('');

      ctrl = '<div class="go-select-wrap">'
        + '<select class="go-select' + (isDisabled ? ' go-select--disabled' : '') + '"'
        + ' id="go-ctrl-' + uid + '"'
        + ' data-option-name="' + ea(opt.name) + '"'
        + (isDisabled ? ' disabled' : '') + '>'
        + placeholderOpt + optHtml
        + '</select>'
        + '<svg class="go-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>'
        + '</div>';

      // Popup links
      if(['CF Shaft', 'CF Grip', 'CF Tip Installed'].includes(opt.name)){
          var txt='';

          switch(opt.name){
              case 'CF Shaft':
                  txt='View Available Shaft Upgrade';
                  break;
              case 'CF Grip':
                  txt='View Available Grip Upgrade';
                  break;
              case 'CF Tip Installed':
                  txt='View Available Adapters';
                  break;
          }

          ctrl+=
              '<div class="go-option-link">'+
                  '<a href="#" class="go-popup-link" data-option="'+
                  ea(opt.name)+
                  '">'+
                  txt+
                  '</a>'+
              '</div>';
      }  

      if (['CF Shaft', 'CF Grip', 'CF Head Cover', 'CF Tip Installed', 'CF_Ferrule', 'Select Color'].includes(opt.name)) {
          ctrl +=
              '<div class="go-option-preview">' +
                  '<img class="go-preview-image" style="display:none;">' +
              '</div>';
      }
    }

    /* ── BUTTONS ── */
    else if (type === 'buttons') {
      var btnsHtml = isDisabled
        ? '<div class="go-btn go-btn--placeholder" disabled>' + et(opt.placeholder) + '</div>'
        : opt.options.map(function(v, i) {
            var p   = v.price_cents || 0;
            var ps  = p > 0 ? ' (+' + money(p) + ')' : '';
            var oos = v.enabled && v.qty === 0;
            var dis = !v.enabled || v.qty === 0;
            var cls = 'go-btn'
              + (i === fei && !dis ? ' active' : '')
              + (!v.enabled ? ' go-btn--disabled' : '')
              + (oos ? ' go-btn--oos' : '');
            var sk = v.sku ? '<span class="go-btn-sku">' + et(v.sku) + '</span>' : '';
            var ol = oos ? '<span class="go-btn-oos-lbl">Out of stock</span>' : '';
            return '<button type="button" class="' + cls + '"'
              + ' data-value="' + p + '" data-label="' + ea(v.label) + '" data-sku="' + ea(v.sku) + '"'
              + (dis ? ' disabled aria-disabled="true"' : '') + '>'
              + et(v.label) + ps + sk + ol + '</button>';
          }).join('');

      ctrl = '<div class="go-buttons' + (isDisabled ? ' go-buttons--disabled' : '') + '"'
        + ' id="go-ctrl-' + uid + '"'
        + ' role="group" aria-label="' + ea(opt.name) + '"'
        + ' data-option-name="' + ea(opt.name) + '">'
        + btnsHtml + '</div>';
    }

    /* ── SWATCHES ── */
    else if (type === 'swatches') {
      var swHtml = isDisabled
        ? '<span class="go-swatch-placeholder">' + et(opt.placeholder) + '</span>'
        : opt.options.map(function(v, i) {
            var p   = v.price_cents || 0;
            var oos = v.enabled && v.qty === 0;
            var dis = !v.enabled || v.qty === 0;
            var cls = 'go-swatch'
              + (i === fei && !dis ? ' active' : '')
              + (!v.enabled ? ' go-swatch--disabled' : '')
              + (oos ? ' go-swatch--oos' : '');
            var ps  = p > 0 ? ' (+' + money(p) + ')' : '';
            var tip = v.label + (v.sku ? ' [' + v.sku + ']' : '') + ps + (oos ? ' — Out of stock' : '');
            return '<button type="button" class="' + cls + '"'
              + ' data-value="' + p + '" data-label="' + ea(v.label) + '" data-sku="' + ea(v.sku) + '"'
              + ' style="background:' + (v.color||'#ccc') + '"'
              + ' title="' + ea(tip) + '" aria-label="' + ea(v.label) + '"'
              + (dis ? ' disabled aria-disabled="true"' : '') + '></button>';
          }).join('');

      ctrl = '<div class="go-swatches' + (isDisabled ? ' go-swatches--disabled' : '') + '"'
        + ' id="go-ctrl-' + uid + '"'
        + ' role="group" aria-label="' + ea(opt.name) + '"'
        + ' data-option-name="' + ea(opt.name) + '">'
        + swHtml + '</div>';
    }

    /* ── TABLE ── */
    else if (type === 'table') {
      var rows = opt.options.map(function(v) {
        var upgradeCents = v.price_cents || 0;
        var displayPrice = basePrice + upgradeCents;
        var oos = v.enabled && v.qty === 0;
        var dis = !v.enabled;
        var cls = 'go-table-row'
          + (dis ? '' : '')
          + (oos ? ' go-table-row--oos' : '');

        var lowStock = !dis && !oos && v.qty <= 10;

        var stockHtml = oos
          ? '<span class="go-stock go-stock--out"><span class="go-stock-dot"></span>Out of Stock</span>'
            + '<button'
                + ' type="button"'
                + ' class="go-notify-btn"'
                + ' data-option-group="' + ea(opt.name) + '"'
                + ' data-option-label="' + ea(v.label) + '"'
                + ' data-sku="' + ea(v.sku) + '">'
                + '<img src="' + window.GoNotifyImage + '" alt="Notify Me">'
            + '</button>'
          : dis
            ? '<span class="go-stock go-stock--out"><span class="go-stock-dot"></span>Out of Stock</span>'
            : lowStock
              ? '<span class="go-stock go-stock--low"><span class="go-stock-dot"></span>Low Qty</span>'
              : '<span class="go-stock go-stock--in"><span class="go-stock-dot"></span>In Stock</span>';
        var priceHtml = '<span class="go-table-price">' + money(displayPrice) + '</span>'
          /*+ (upgradeCents > 0 ? '<span class="go-table-upgrade">(+' + money(upgradeCents) + ')</span>' : '')*/;
        var skuHtml = v.sku ? '<span class="go-table-sku">' + et(v.sku) + '</span>' : '';
        var qtyHtml = (!dis && !oos)
          ? '<div class="go-qty-ctrl" role="group" aria-label="Qty for ' + ea(v.label) + '">'
              + '<button type="button" class="go-qty-btn qty-decrease" data-action="minus" aria-label="Decrease"><i class="fa fa-minus"></i></button>'
              + '<input type="number" class="go-qty-input" value="0" min="0" max="' + v.qty + '"'
              + ' data-label="' + ea(v.label) + '" data-sku="' + ea(v.sku) + '"'
              + ' data-price="' + upgradeCents + '" data-display-price="' + displayPrice + '"'
              + ' aria-label="Qty for ' + ea(v.label) + '">'
              + '<button type="button" class="go-qty-btn qty-increase" data-action="plus" aria-label="Increase"><i class="fa fa-plus"></i></button>'
            + '</div>'
          : '<span class="go-qty-na"></span>';
        return '<tr class="' + cls + '">'
          + '<td class="go-td-name"><span class="go-table-label">' + et(v.label) + skuHtml + '</span></td>'
          + '<td class="go-td-price">' + priceHtml + '</td>'
          + '<td class="go-td-qty">' + stockHtml + qtyHtml + '</td>'
          + '</tr>';
      }).join('');

      var allOutOfStock = opt.options.every(function(v) {
         return !v.enabled || v.qty === 0;
      });

      ctrl = '<div class="go-table-wrap">'
        + '<table class="go-table' + (allOutOfStock ? ' go-table--all-no-margin' : '') + '" id="go-ctrl-' + uid + '" data-option-name="' + ea(opt.name) + '">'
        + '<thead><tr>'
        + '<th>' + et(opt.name) + '</th><th>Price</th>'
        + '<th class="go-th-qty">Qty</th>'
        + '</tr></thead>'
        + '<tbody>' + rows + '</tbody>'
        + '</table>'
        + '<div class="go-table-summary" id="go-summary-' + uid + '"' + (allOutOfStock ? ' style="display:none;"' : '') + '>'
        + '<span class="review_order">Review Your Order</span>'
        + '<div class="product-summary">'
        + '<span class="product-items">'
        + 'Number of items: '
        + '<span id="go-tbl-count-' + uid + '">0</span>'
        + '</span>'
        + '<span class="product-list-total" style="display:none;">'
        + 'List Total: '
        + '<span id="go-tbl-list-total-' + uid + '">$0.00</span>'
        + '</span>'
        + '<span class="product-upgrade-total" style="display:none;">'
        + 'Upgrade Total: '
        + '<span id="go-tbl-upgrade-total-' + uid + '">$0.00</span>'
        + '</span>'
        + '<span class="product-totals">'
        + 'Subtotal: '
        + '<strong id="go-tbl-total-' + uid + '">$0.00</strong>'
        + '</span>'
        + '</div>'
        + '</div></div>';
    }

    return '<div class="go-option-block go-option-block-'+ type +'" data-opt-type="' + type + '" data-opt-name="' + ea(opt.name) + '" id="go-block-' + uid + '">'
      + labelHtml + ctrl + '</div>';
  }

  /* ── TABLE controls ── */
  function initTableControls(wrapper, uid) {
    var table   = document.getElementById('go-ctrl-' + uid);
    var countEl = document.getElementById('go-tbl-count-' + uid);
    var totalEl = document.getElementById('go-tbl-total-' + uid);
    if (!table) return;
    
    function updateSummary() {

      var items = 0;
      var tableUpgradeTotal = 0;
      var listTotal = 0;

      qsa('.go-qty-input', table).forEach(function(inp) {

        var q =
          parseInt(inp.value, 10) || 0;

        var up =
          parseInt(inp.dataset.price, 10) || 0;

        var displayPrice =
          parseInt(
            inp.dataset.displayPrice,
            10
          ) || 0;

        items += q;

        tableUpgradeTotal +=
          q * up;

        listTotal +=
          q * displayPrice;

      });

      /*
      |--------------------------------------------------------------------------
      | Dropdown upgrade total
      |--------------------------------------------------------------------------
      */

      var wrapper =
        table.closest(
          '.go-wrapper[data-product-id]'
        );

      var dropdownUpgradeTotal = 0;

      if (wrapper) {

        qsa(
          '.go-option-block',
          wrapper
        ).forEach(function(block) {

          if (
            block.dataset.optType ===
            'table'
          ) {
            return;
          }

          var select =
            block.querySelector(
              'select'
            );

          if (select) {

            dropdownUpgradeTotal +=
              parseInt(
                select.value,
                10
              ) || 0;
          }

          var active =
            block.querySelector(
              '.active'
            );

          if (
            active &&
            active.dataset.value
          ) {

            dropdownUpgradeTotal +=
              parseInt(
                active.dataset.value,
                10
              ) || 0;
          }

        });

      }

      /*
      |--------------------------------------------------------------------------
      | Combined mode?
      |--------------------------------------------------------------------------
      */

      var hasDropdown =
        wrapper &&
        (
          wrapper.classList.contains('go-wrapper-dropdown') ||
          wrapper.classList.contains('go-wrapper-buttons') ||
          wrapper.classList.contains('go-wrapper-swatches')
        );

      /*
      |--------------------------------------------------------------------------
      | Qty 0 = reset everything
      |--------------------------------------------------------------------------
      */

      if (items === 0) {

        dropdownUpgradeTotal = 0;

      }

      /*
      |--------------------------------------------------------------------------
      | Multiply dropdown upgrade by table qty
      |--------------------------------------------------------------------------
      */

      var effectiveDropdownUpgrade =
        dropdownUpgradeTotal * items;

      var subtotal =
        listTotal +
        effectiveDropdownUpgrade;

      if (countEl) {
        countEl.textContent =
          items;
      }

      /*
      |--------------------------------------------------------------------------
      | Elements
      |--------------------------------------------------------------------------
      */

      var listEl =
        document.getElementById(
          'go-tbl-list-total-' +
          uid
        );

      var upgradeEl =
        document.getElementById(
          'go-tbl-upgrade-total-' +
          uid
        );

      if (
        hasDropdown
      ) {

        if (listEl) {
          listEl.parentElement.style.display =
            '';
          listEl.textContent =
            money(listTotal);
        }

        if (upgradeEl) {
          upgradeEl.parentElement.style.display =
            '';
          upgradeEl.textContent =
            money(
              effectiveDropdownUpgrade
            );
        }

        if (totalEl) {
          totalEl.textContent =
            money(subtotal);
        }

      } else {

        if (listEl) {
          listEl.parentElement.style.display =
            'none';
        }

        if (upgradeEl) {
          upgradeEl.parentElement.style.display =
            'none';
        }

        if (totalEl) {
          totalEl.textContent =
            money(listTotal);
        }

      }

      table.dataset.upgradeTotal =
        tableUpgradeTotal +
        effectiveDropdownUpgrade;

      table.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );

    }

    qsa('.go-qty-btn', table).forEach(function(btn) {
      btn.addEventListener('click', function() {
        var inp = qs('.go-qty-input', btn.closest('.go-qty-ctrl'));
        var v = parseInt(inp.value,10)||0, max = parseInt(inp.max,10)||999;
        inp.value = btn.dataset.action==='plus' ? Math.min(v+1,max) : Math.max(v-1,0);
        updateSummary();
      });
    });
    qsa('.go-qty-input', table).forEach(function(inp) {
      inp.addEventListener('input', function() {
        var v = parseInt(inp.value,10);
        if (isNaN(v)||v<0) inp.value=0;
        updateSummary();
      });
    });

    /* Initial render */
    updateSummary();
  }

  /* ────────────────────────────────────────────────────────────
     CONDITIONAL CHAIN ENGINE
     Handles: A→B, A→B→C, A→[B,C], any depth, any fan-out.

     FIX: Apply filters in dependency ORDER so that when page
     loads with a pre-selected parent (e.g. #3 RH auto-selected),
     all downstream filters run correctly top-to-bottom.
  ──────────────────────────────────────────────────────────── */
  function initConditionals(wrapper, resolved, pid, proxies, onAnyChange) {

    var nameToIndex = {};
    resolved.forEach(function(opt, i) { nameToIndex[opt.name] = i; });

    /* Build a reusable applyFilter function per conditional option */
    var filterFns = {}; /* optName → applyFilter fn */

    resolved.forEach(function(opt, i) {
      if (!opt.conditions) return;

      var cond       = opt.conditions;
      var parentName = cond.depends_on;
      var map        = cond.map || {};
      var pi         = nameToIndex[parentName];
      if (pi === undefined) return;

      var uid       = pid + '-opt' + i;
      var parentUid = pid + '-opt' + pi;
      var parentOpt = resolved[pi];
      var pType     = parentOpt.displayType;
      var pCtrl     = document.getElementById('go-ctrl-' + parentUid);
      var cCtrl     = document.getElementById('go-ctrl-' + uid);
      var valEl     = document.getElementById('go-val-' + uid);

      /* Get currently selected label from parent control */
      function getParentLabel() {
        if (pType === 'dropdown' && pCtrl) {
          var sel = pCtrl.options[pCtrl.selectedIndex];
          /* Only return label if a real option is selected (not placeholder) */
          return (sel && sel.value !== '') ? (sel.dataset.label || sel.text || '') : '';
        }
        var active = pCtrl ? pCtrl.querySelector('.active') : null;
        return active ? (active.dataset.label || '') : '';
      }

      function applyFilter(isInitialLoad) {
        var parentVal   = getParentLabel();
        var allowedVals = parentVal ? (map[parentVal] || null) : null;
        var childType   = opt.displayType;

        if (childType === 'dropdown' && cCtrl) {

          if (!parentVal) {
            /* ── No parent selected: disable + hide all real options ── */
            cCtrl.disabled = true;
            cCtrl.classList.add('go-select--disabled');
            /* Reset to placeholder */
            Array.from(cCtrl.options).forEach(function(o) {
              if (o.value === '') { o.selected = true; o.hidden = false; o.disabled = false; }
              else               { o.hidden = true;  o.disabled = true; }
            });
            cCtrl.value = '';
            if (valEl) valEl.textContent = '';

          } else {
            /* ── Parent selected: enable + filter ── */
            cCtrl.disabled = false;
            cCtrl.classList.remove('go-select--disabled');

            var firstVisible = null;

            Array.from(cCtrl.options).forEach(function(o) {

              if (o.value === '') {
                o.hidden = false;
                o.disabled = false;
                return;
              }

              var label = o.dataset.label || o.text;
              var allowed = !allowedVals || allowedVals.indexOf(label) !== -1;

              o.hidden = !allowed;
              o.disabled = !allowed;

              if (allowed && !firstVisible) {
                firstVisible = o;
              }
            });

            /* ALWAYS select first allowed value */
            if (firstVisible) {

              cCtrl.selectedIndex = firstVisible.index;

              Array.from(cCtrl.options).forEach(function(o, idx) {
                o.selected = (idx === firstVisible.index);
              });


              if (valEl) {
                valEl.textContent = firstVisible.dataset.label || firstVisible.text;
              }
            }
          }

          /* Flash animation (skip on initial silent load) */
          if (!isInitialLoad) {
            cCtrl.classList.remove('go-conditional-updated');
            void cCtrl.offsetWidth;
            cCtrl.classList.add('go-conditional-updated');
            setTimeout(function() { cCtrl.classList.remove('go-conditional-updated'); }, 400);
          }

          /* Propagate downstream */
          cCtrl.dispatchEvent(new Event('change', { bubbles: true }));

        } else if ((childType === 'buttons' || childType === 'swatches') && cCtrl) {

          if (!parentVal) {
            cCtrl.classList.add('go-control--disabled');
            if (valEl) valEl.textContent = '';
            cCtrl.querySelectorAll('button').forEach(function(b) {
              b.classList.remove('active');
              b.style.display = 'none';
            });
          } else {
            cCtrl.classList.remove('go-control--disabled');
            var firstVisible = null;
            var currentLabel = valEl ? valEl.textContent : '';
            var currentStillValid = false;

            cCtrl.querySelectorAll('button[data-label]').forEach(function(btn) {
              var label   = btn.dataset.label || '';
              var allowed = !allowedVals || allowedVals.indexOf(label) !== -1;
              btn.style.display = allowed ? '' : 'none';
              btn.classList.remove('active');
              if (allowed && !firstVisible && !btn.disabled) firstVisible = btn;
              if (allowed && label === currentLabel) currentStillValid = true;
            });

            if (firstVisible && (!currentStillValid || isInitialLoad)) {
              firstVisible.classList.add('active');
              if (valEl) valEl.textContent = firstVisible.dataset.label || '';
            }
          }

          cCtrl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (onAnyChange) onAnyChange();
      }

      /* Store for ordered initial run */
      filterFns[opt.name] = applyFilter;

      /* Wire parent → child on user interaction */
      if (pCtrl) {
        pCtrl.addEventListener('change', function() {
          setTimeout(function() { applyFilter(false); }, 0);
        });
        if (pType !== 'dropdown') {
          pCtrl.querySelectorAll('button').forEach(function(btn) {
            btn.addEventListener('click', function() {
              setTimeout(function() { applyFilter(false); }, 20);
            });
          });
        }
      }
    });

    /* ── Apply all filters on initial load IN DEPENDENCY ORDER ──
       Walk the chain: find options that have no dependencies first,
       then their dependents, etc. (topological sort by dependency depth).
       This ensures CF Loft filter runs BEFORE CF Flex filter, which runs
       BEFORE CF Shaft filter, and so on down the chain.
    ── */
    function getDependencyDepth(optName, depth) {
      depth = depth || 0;
      var opt = resolved[nameToIndex[optName]];
      if (!opt || !opt.conditions) return depth;
      return getDependencyDepth(opt.conditions.depends_on, depth + 1);
    }

    /* Sort options by dependency depth (shallowest first) */
    var sortedNames = resolved
      .filter(function(opt) { return filterFns[opt.name]; })
      .map(function(opt) {
        return { name: opt.name, depth: getDependencyDepth(opt.name, 0) };
      })
      .sort(function(a, b) { return a.depth - b.depth; })
      .map(function(x) { return x.name; });

    /* Run each filter silently in order */
    sortedNames.forEach(function(name) {
      if (filterFns[name]) filterFns[name](true /* isInitialLoad */);
    });
  }
  /* ── Upgrade Total + Subtotal live update ── */
  function initPriceSummary(wrapper, proxies, basePrice) {
    /* Only show if any option has price_cents > 0 */
    var hasTable = proxies.some(function(p) {
      return p.getDisplayType() === 'table';
    });
    if (hasTable) return;

    var nonTableCount = proxies.filter(function(p) {
      return p.getDisplayType() !== 'table';
    }).length;

    if (nonTableCount <= 1) {
      return; // hide Upgrade Total/Subtotal when only 1 dropdown/button/swatch exists
    }
    
    /* Create summary box just above the go-wrapper bottom */
    var summaryEl = document.createElement('div');
    summaryEl.className = 'go-price-summary';
    summaryEl.id = 'go-price-summary-' + wrapper.dataset.productId;
    summaryEl.innerHTML =
      '<div class="go-price-summary-row">'
        + '<span>Upgrade Total:</span>'
        + '<span id="go-upgrade-total-' + wrapper.dataset.productId + '">$0.00</span>'
      + '</div>'
      + '<div class="go-price-summary-row go-price-summary-row--total">'
        + '<span>Subtotal:</span>'
        + '<span id="go-subtotal-' + wrapper.dataset.productId + '">' + money(basePrice) + '</span>'
      + '</div>';
    wrapper.appendChild(summaryEl);

    function updatePriceSummary() {
      var upgradeCents = 0;
      proxies.forEach(function(p) {
        if (p.getDisplayType() !== 'table') upgradeCents += p.getPrice();
      });
      var upgradeEl  = document.getElementById('go-upgrade-total-' + wrapper.dataset.productId);
      var subtotalEl = document.getElementById('go-subtotal-'       + wrapper.dataset.productId);
      if (upgradeEl)  upgradeEl.textContent  = money(upgradeCents);
      if (subtotalEl) subtotalEl.textContent = money(basePrice + upgradeCents);
    }

    proxies.forEach(function(p) { p.onChange(updatePriceSummary); });
    updatePriceSummary();
  }

  /* ────────────────────────────────────────────────────────────
     BUILD all blocks + return proxies
  ──────────────────────────────────────────────────────────── */
  function buildBlocks(wrapper) {
    var pid        = wrapper.dataset.productId;
    var globalOpts = safeJSON(wrapper.dataset.globalOptions);
    var productCfg = safeJSON(wrapper.dataset.productConfig);
    if (!globalOpts || !productCfg) { console.warn('[GlobalOptions] JSON parse failed.'); return []; }

    var resolved = resolveOptions(globalOpts, productCfg);
    wrapper.resolvedOptions=resolved;
    wrapper.globalOptions=globalOpts;
    if (!resolved.length) { console.warn('[GlobalOptions] No options resolved.'); return []; }

    var basePrice  = parseInt(wrapper.dataset.basePrice, 10) || 0;

    /* Determine which options have a parent (so they start disabled) */
    var hasParentSet = {};

    resolved.forEach(function(opt) {

      wrapper.classList.add(
        'go-wrapper-' + opt.displayType
      );

      if (
        opt.name === 'CF Shaft' ||
        opt.name === 'CF Grip'
      ) {

        //hasParentSet[opt.name] = true;

      }

    });

    var hasTableOption =
      resolved.some(function(opt){

        return opt.displayType === 'table';

      });

    wrapper.innerHTML = resolved.map(function(opt, i) {
      return renderBlock(opt, i, pid, basePrice, !!hasParentSet[opt.name], hasTableOption);
    }).join('');

    /* Wire table controls */
    resolved.forEach(function(opt, i) {
      if (opt.displayType === 'table') initTableControls(wrapper, pid + '-opt' + i);
    });

    /* Build proxies */
    var proxies = resolved.map(function(opt, i) {
      var uid   = pid + '-opt' + i;
      var type  = opt.displayType;
      var c     = document.getElementById('go-ctrl-' + uid);
      var valEl = document.getElementById('go-val-' + uid);

      function getLabel() {
        if (type === 'dropdown' && c) {
          var s = c.options[c.selectedIndex];
          return (s && s.value !== '') ? (s.dataset.label || s.text || '') : '';
        }
        if (type === 'table') return '';
        var a = c ? c.querySelector('.active') : null;
        return a ? (a.dataset.label || '') : '';
      }
      function getSku() {
        if (type === 'dropdown' && c) { var s = c.options[c.selectedIndex]; return s ? (s.dataset.sku||'') : ''; }
        if (type === 'table') return '';
        var a = c ? c.querySelector('.active') : null;
        return a ? (a.dataset.sku||'') : '';
      }
      function getPrice() {
        if (type === 'dropdown' && c) return parseInt(c.value, 10) || 0;
        if (type === 'table')        return c ? (parseInt(c.dataset.upgradeTotal,10)||0) : 0;
        var a = c ? c.querySelector('.active') : null;
        return a ? (parseInt(a.dataset.value,10)||0) : 0;
      }
      function getTableSelections() {
        if (type !== 'table' || !c) return [];
        var items = [];
        qsa('.go-qty-input', c).forEach(function(inp) {
          var q = parseInt(inp.value,10)||0;
          if (q > 0) items.push({ label: inp.dataset.label||'', sku: inp.dataset.sku||'', qty: q, price_cents: parseInt(inp.dataset.price,10)||0 });
        });
        return items;
      }
      function upd() { if (valEl) valEl.textContent = getLabel(); }

      if (type === 'dropdown' && c) {
        //c.addEventListener('change', upd);
        c.addEventListener('change', function(){
            upd();

            var option =
                c.options[c.selectedIndex];
            var preview =
                c.closest('.go-option-block')
                .querySelector('.go-preview-image');

            if (!preview)
                return;

            var image =
                option.dataset.image || '';

            if (image) {
                preview.src =
                    image.startsWith('http')
                        ? image
                        : window.SHOPIFY_FILES_BASE + image;

                preview.style.display = '';
            } else {
                preview.removeAttribute('src');
                preview.style.display = 'none';
            }
        });
      } else if (type !== 'table' && c) {
        c.querySelectorAll('button:not([disabled])').forEach(function(btn) {
          btn.addEventListener('click', function() {
            c.querySelectorAll('button').forEach(function(b) { b.classList.remove('active'); });
            btn.classList.add('active'); upd();
            c.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
      upd();

      return {
        getName           : function() { return opt.name; },
        getDisplayType    : function() { return type; },
        getLabel          : getLabel,
        getSku            : getSku,
        getPrice          : getPrice,
        getTableSelections: getTableSelections,
        onChange          : function(fn) { if (c) c.addEventListener('change', fn); }
      };
    });

    /* Wire conditionals AFTER proxies built */
    //initConditionals(wrapper, resolved, pid, proxies, null);

    /* Upgrade Total + Subtotal */
    initPriceSummary(wrapper, proxies, basePrice);

    return proxies;
  }

  /* ── Cart helpers ── */
  function addHidden(form, name, value) {
    var inp = document.createElement('input');
    inp.type = 'hidden'; inp.name = name; inp.value = value;
    inp.classList.add('go-injected');
    form.appendChild(inp);
  }

  function injectFormInputs(wrapper, proxies) {
    var form = findCartForm(wrapper);
    if (!form) return;
    qsa('.go-injected', form).forEach(function(el) { el.remove(); });
    proxies.forEach(function(p) {
      if (p.getDisplayType() === 'table') return;
      var name = p.getName(), label = p.getLabel(), sku = p.getSku(), price = p.getPrice();
      if (!label) return;
      addHidden(form, 'properties[' + name + ']', label);
      if (sku)       addHidden(form, 'properties[_' + name + ' SKU]', sku);
      if (price > 0) addHidden(form, 'properties[' + name + ' Upgrade]', money(price));
    });
  }

  function buildTableLineItems(wrapper, proxies) {

    var sharedProps = {};
    var sharedUpgradeCents = 0;

    proxies.forEach(function(p) {

      if (p.getDisplayType() === 'table') return;

      var name = p.getName();
      var label = p.getLabel();
      var sku = p.getSku();
      var price = p.getPrice();

      if (name && label) {

        sharedProps[name] = label;

        if (sku) {
          sharedProps['_' + name + ' SKU'] = sku;
        }

        if (price > 0) {
          sharedUpgradeCents += price;
        }
      }

    });

    var form = findCartForm(wrapper);

    var variantId = form
      ? parseInt(
          (qs('[name="id"]', form) || {}).value,
          10
        )
      : 0;

    var lineItems = [];

    proxies.forEach(function(p) {

      if (p.getDisplayType() !== 'table') return;

      var name = p.getName();

      p.getTableSelections().forEach(function(it) {

        /*
        * IMPORTANT
        * Same option => same group
        * Different option => different group
        */

        const configGroup =
          variantId +
          '_' +
          name +
          '_' +
          it.label;

        var props = Object.assign({}, sharedProps);

        props[name] = it.label;

        props['_config_group'] = configGroup;

        props['_upgrade_cents'] =
          sharedUpgradeCents +
          (it.price_cents || 0);

        if (it.sku) {
          props['_' + name + ' SKU'] = it.sku;
        }

        /*
        * MAIN PRODUCT
        */

        lineItems.push({
          id: variantId,
          quantity: it.qty,
          properties: props
        });

        /*
        * UPGRADE PRODUCT
        */

        /*
|--------------------------------------------------------------------------
| UPGRADE PRODUCT
|--------------------------------------------------------------------------
*/

var totalUpgradeCents =
  sharedUpgradeCents +
  (it.price_cents || 0);

if (totalUpgradeCents > 0) {

  const upgradeVariantId =
    window.UPGRADE_VARIANTS[
      totalUpgradeCents
    ];

  if (upgradeVariantId) {

    var upgradeProps = {

      _upgrade_fee: 'true',

      _config_group:
        configGroup,

      _upgrade_cents:
        totalUpgradeCents

    };

    /*
    |--------------------------------------------------------------------------
    | Add selected dropdown/button/swatch options
    |--------------------------------------------------------------------------
    */

    proxies.forEach(function(proxy) {

      if (
        proxy.getDisplayType() === 'table'
      ) {
        return;
      }

      var optionName =
        proxy.getName();

      var optionLabel =
        proxy.getLabel();

      if (
        optionName &&
        optionLabel
      ) {

        upgradeProps[
          optionName
        ] = optionLabel;

      }

    });

    /*
    |--------------------------------------------------------------------------
    | Add current table row
    |--------------------------------------------------------------------------
    */

    upgradeProps[name] =
      it.label;

    lineItems.push({

      id: upgradeVariantId,

      quantity: it.qty,

      properties:
        upgradeProps

    });

  } else {

    console.warn(
      'No upgrade variant mapping for:',
      totalUpgradeCents
    );

  }

}

      });

    });

    return lineItems;

  }

  function hasTableOptions(proxies) {
    return proxies.some(function(p) { return p.getDisplayType() === 'table'; });
  }

  function addTableItemsToCart(lineItems, onSuccess, onError) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-GO-Source': 'global-options'   /* marks this as our call — skip redirect intercept */
      },
      body: JSON.stringify({ items: lineItems })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw new Error(d.description||'Cart error'); });
      return r.json();
    })
    .then(onSuccess).catch(onError);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        qsa('[data-cart-count],.cart-count,.header__cart-count,#CartCount').forEach(function(el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      });
  }

  function dispatchChange(wrapper, proxies) {
    wrapper.dispatchEvent(new CustomEvent('go:change', {
      bubbles: true,
      detail: { selections: proxies.map(function(p) {
        return { name: p.getName(), type: p.getDisplayType(), label: p.getLabel(), sku: p.getSku(), price_cents: p.getPrice(), tableItems: p.getTableSelections() };
      })}
    }));
  }

  /* ── Validate ── */
  function makeValidator(wrapper, proxies) {
    return function validate() {
      var hasSelection = false, errorMessage = '';
      proxies.forEach(function(p) {
        if (p.getDisplayType() !== 'table') return;
        var uid = wrapper.dataset.productId + '-opt' + proxies.indexOf(p);
        var tbl = document.getElementById('go-ctrl-' + uid);
        if (!tbl) return;
        qsa('.go-qty-input', tbl).forEach(function(inp) {
          var qty = parseInt(inp.value,10)||0, max = parseInt(inp.max,10)||0;
          if (qty > 0) hasSelection = true;
          if (qty > max) errorMessage = inp.dataset.label + ' only has ' + max + ' units available.';
        });
      });
      return { valid: hasSelection && !errorMessage, error: errorMessage };
    };
  }

  /* ── initAddToCart: unified button handler for table + dropdown ────────
     Replaces Horizon's submit button with our own type="button".
     - Table options   → validates qty, adds each row as line item
     - Dropdown/buttons → adds single item with option properties
     Both redirect to /cart instantly on success.
  ──────────────────────────────────────────────────────────────────────── */
  function validateRequiredOptions(proxies) {

    for (var i = 0; i < proxies.length; i++) {

      var p = proxies[i];

      if (p.getDisplayType() === 'table') continue;

      if (!p.getLabel()) {
        return {
          valid: false,
          option: p.getName()
        };
      }
    }

    return {
      valid: true
    };
  }

  function initAddToCart(wrapper, proxies) {
    var form = findCartForm(wrapper);
    if (!form) return;

    var origBtn = qs('[name="add"]', form)
               || qs('button[type="submit"].add-to-cart-button', form)
               || qs('button[type="submit"]', form);
    if (!origBtn) return;

    /* Error element — inserted before the button */
    var errEl = document.createElement('div');
    errEl.className = 'go-validation-error';
    errEl.style.display = 'none';
    origBtn.parentNode.insertBefore(errEl, origBtn);

    function showError(msg) {
      errEl.textContent = msg;
      errEl.style.display = 'flex';
      errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      clearTimeout(errEl._timer);
      errEl._timer = setTimeout(function() { errEl.style.display = 'none'; }, 3000);
    }
    function hideError() { errEl.style.display = 'none'; clearTimeout(errEl._timer); }

    /* Table validation */
    var validate    = makeValidator(wrapper, proxies);
    var isTable     = hasTableOptions(proxies);
    var isNonTable  = proxies.some(function(p) { return p.getDisplayType() !== 'table'; });

    function getOptNames() {
      return proxies.filter(function(p) { return p.getDisplayType()==='table'; })
        .map(function(p){ return p.getName(); }).join(', ');
    }

    /* Replace original button */
    var goBtn = document.createElement('button');
    goBtn.type = 'button';
    goBtn.className = origBtn.className;
    goBtn.innerHTML = origBtn.innerHTML;
    goBtn.setAttribute('aria-label', origBtn.getAttribute('aria-label') || 'Add to cart');
    origBtn.style.display = 'none';
    origBtn.parentNode.insertBefore(goBtn, origBtn.nextSibling);

    /* Start: Hide button if qty<=0 or button is disable */
    function shouldHideAddToCart() {
      var tableOptions = (wrapper.resolvedOptions || []).filter(function(opt) {
        return opt.displayType === 'table';
      });

      return tableOptions.some(function(opt) {
        return opt.options.length === 0 || opt.options.every(function(v) {
          return !v.enabled || Number(v.qty) <= 0;
        });
      });
    }

    goBtn.style.display = shouldHideAddToCart() ? 'none' : '';
    /* End: Hide button if qty<=0 or button is disable */

    /* Hide error on qty change */
    wrapper.addEventListener('input', function(e) {
      if (e.target.classList.contains('go-qty-input') && validate().valid) hideError();
    });

    /* ── Click handler ── */
    goBtn.addEventListener('click', function() {

      /* Validate required dropdowns */
      var optionValidation = validateRequiredOptions(proxies);

      if (!optionValidation.valid) {

        showError(
          'Please select ' + optionValidation.option + '.'
        );

        var block = document.querySelector(
          '.go-option-block[data-opt-name="' +
          optionValidation.option +
          '"]'
        );

        if (block) {

          block.classList.add('go-shake');

          setTimeout(function() {
            block.classList.remove('go-shake');
          }, 600);

          block.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }

        return;
      }

      /* 1. Validate table qty if product has table options */
      if (isTable) {
        var result = validate();
        if (!result.valid) {
          var msg = result.error ||
            ('Please select at least one option from ' + getOptNames() + ' before adding to cart.');
          showError(msg);
          proxies.forEach(function(p) {
            if (p.getDisplayType() !== 'table') return;
            var uid = wrapper.dataset.productId + '-opt' + proxies.indexOf(p);
            var tbl = document.getElementById('go-ctrl-' + uid);
            if (tbl) {
              tbl.classList.add('go-shake');
              setTimeout(function() { tbl.classList.remove('go-shake'); }, 600);
            }
          });
          return;
        }
      }

      hideError();
      goBtn.disabled = true;
      var origHTML = goBtn.innerHTML;

      function onSuccess() {
        window.location.href = '/cart'; /* instant redirect */
      }
      function onError(err) {
        goBtn.disabled = false;
        goBtn.innerHTML = origHTML;
        showError('Could not add to cart: ' + (err.message || 'Please try again.'));
      }

      /* 2a. Table: add each selected row as separate line item */
      if (isTable) {
        var lineItems = buildTableLineItems(wrapper, proxies);
        addTableItemsToCart(lineItems, onSuccess, onError);
        return;
      }

      /* 2b. Dropdown/buttons/swatches only: add single item with properties */
      var variantInput = qs('[name="id"]', form)
                      || qs('[ref="variantId"]', form);
      var variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
      if (!variantId) { showError('No product variant found.'); goBtn.disabled = false; return; }

      var qtyInput = qs('[name="quantity"]', form)
                  || qs('quantity-selector input', form)
                  || qs('input.quantity-input', form);
      var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var properties = {};
      var totalUpgradeCents = 0;

      proxies.forEach(function(p) {

        var name  = p.getName();
        var label = p.getLabel();
        var sku   = p.getSku();
        var price = p.getPrice();

        if (name && label) {

          properties[name] = label;

          if (sku) {
            properties['_' + name + ' SKU'] = sku;
          }

          if (price > 0) {

            properties[name + ' Upgrade'] =
              money(price);

            totalUpgradeCents += price;
          }
        }

      });

      /*
      |--------------------------------------------------------------------------
      | Same as table products
      |--------------------------------------------------------------------------
      */

      properties['_upgrade_cents'] =
        totalUpgradeCents;

      var items = [];

      /*
      |--------------------------------------------------------------------------
      | Main Product
      |--------------------------------------------------------------------------
      */

      const configGroup =
        variantId +
        '_' +
        Date.now();

      var item = {
        id: variantId,
        quantity: quantity,
        properties: Object.assign(
          {},
          properties,
          {
            _config_group: configGroup
          }
        )
      };

      items.push(item);

      /*
      |--------------------------------------------------------------------------
      | Upgrade Fee Products
      |--------------------------------------------------------------------------
      */

      proxies.forEach(function(p) {

        var price = p.getPrice();

        if (price <= 0) return;

        const upgradeVariantId =
          window.UPGRADE_VARIANTS[price];

        if (!upgradeVariantId) {

          console.warn(
            'No upgrade variant mapping for:',
            price
          );

          return;
        }

        items.push({

          id: upgradeVariantId,

          quantity: quantity,

          properties: {

            _upgrade_fee: 'true',

            _config_group: configGroup,

            [p.getName()]: p.getLabel(),

            _upgrade_cents: price

          }

        });

      });

      fetch('/cart/add.js', {
        method  : 'POST',
        headers : {
          'Content-Type'     : 'application/json',
          'X-Requested-With' : 'XMLHttpRequest',
          'X-GO-Source'      : 'global-options'
        },
        body: JSON.stringify({
          items: items
        })
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || 'Cart error'); });
        return r.json();
      })
      .then(onSuccess)
      .catch(onError);
    });
  }

  /* ── initInstance: kept for backward compat — now just builds blocks ── */
  function initInstance(wrapper) {
    /* no-op: buildBlocks + initAddToCart called in initAll */
  }

  /* ── Early validation ── */
  function initEarlyValidation() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[name="add"], button[type="submit"].add-to-cart-button');
      if (!btn) return;
      var wrapper = qs('.go-wrapper[data-product-id]');
      if (!wrapper || !qsa('.go-table', wrapper).length) return;
      var hasSelection = qsa('.go-qty-input', wrapper).some(function(inp) { return (parseInt(inp.value,10)||0) > 0; });
      if (hasSelection) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var errEl = qs('.go-validation-error') || document.createElement('div');
      if (!errEl.parentNode) { errEl.className = 'go-validation-error'; btn.parentNode.insertBefore(errEl, btn); }
      var names = qsa('.go-table thead th:first-child', wrapper).map(function(th){ return th.textContent.trim(); }).filter(Boolean);
      errEl.textContent = 'Please select at least one ' + (names.join(', ')||'option') + ' before adding to cart.';
      errEl.style.display = 'flex';
      clearTimeout(errEl._timer);
      errEl._timer = setTimeout(function() { errEl.style.display = 'none'; }, 3000);
      qsa('.go-table', wrapper).forEach(function(tbl) {
        tbl.classList.remove('go-shake'); void tbl.offsetWidth; tbl.classList.add('go-shake');
        setTimeout(function() { tbl.classList.remove('go-shake'); }, 600);
      });
      errEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, true);
  }

  function getFilteredOptions(
    optionName,
    parentValue,
    options
  ) {

    const filters =
      window.OPTION_FILTERS || {};

    const rule =
      filters[optionName];

    if (
      !rule ||
      !parentValue
    ) {
      return options;
    }

    const allowed =
      rule[parentValue];

    if (
      !Array.isArray(allowed)
    ) {
      return [];
    }

    return options.filter(
      function(opt) {

        return allowed.includes(
          opt.label
        );

      }
    );

  }

  function initShopFilters(
    wrapper,
    proxies
  ) {

    const proxyMap = {};

    proxies.forEach(function(p) {

      proxyMap[
        p.getName()
      ] = p;

    });

    /*
    const flexProxy =
      proxyMap['CF Flex'];

    const shaftProxy =
      proxyMap['CF Shaft'];

    const gripSizeProxy =
      proxyMap['CF Grip Size'];

    const gripProxy =
      proxyMap['CF Grip'];

    if (
      !flexProxy ||
      !shaftProxy ||
      !gripSizeProxy ||
      !gripProxy
    ) {
      return;
    }
    */

    function updateFilteredDropdown(
      parentName,
      childName
    ) {

      const parentBlock =
        wrapper.querySelector(
          '[data-opt-name="' +
          parentName +
          '"]'
        );

      const childBlock =
        wrapper.querySelector(
          '[data-opt-name="' +
          childName +
          '"]'
        );

      if (
        !parentBlock ||
        !childBlock
      ) {
        return;
      }

      const parentSelect =
        parentBlock.querySelector(
          'select'
        );

      const childSelect =
        childBlock.querySelector(
          'select'
        );

      if (
        !parentSelect ||
        !childSelect
      ) {
        return;
      }

      const selectedParent =
        parentSelect.options[
          parentSelect.selectedIndex
        ]?.dataset?.label || '';

      const filters =
        window.OPTION_FILTERS ||
        {};

      const mapping =
        filters[childName] ||
        {};

      if (!selectedParent) {

        Array.from(
          childSelect.options
        ).forEach(function(opt){

            if (!opt.dataset.label) {
              return;
            }

            const enabled =
              opt.dataset.enabled !== '0';

            const qty =
              parseInt(
                opt.dataset.qty || '0',
                10
              );  

            opt.hidden = false;
            
            opt.disabled =
              !enabled ||
              qty <= 0;

        });

        childSelect.value = '';

        return;
      }

      const allowed =
        mapping[selectedParent];

      if (!allowed) {
        return;
      }

      let firstAllowed =
        null;

      Array.from(
        childSelect.options
      ).forEach(function(opt) {

        if (
          !opt.dataset.label
        ) {
          return;
        }

        const show =
          allowed.includes(
            opt.dataset.label
          );

        const enabled =
          opt.dataset.enabled !== '0';

        const qty =
          parseInt(
            opt.dataset.qty || '0',
            10
          );  

        opt.hidden =
          !show;

        opt.disabled =
          !show || !enabled || qty <= 0;

        childSelect.value = '';  

        if (
          show &&
          !firstAllowed
        ) {

          firstAllowed =
            opt;

        }

      });

      if (
        firstAllowed
      ) {

        //childSelect.value =
          //firstAllowed.value;

        childSelect.dispatchEvent(
          new Event(
            'change',
            {
              bubbles:true
            }
          )
        );

      }

    }

    const flexSelect =
      wrapper.querySelector(
        '[data-opt-name="CF Flex"] select'
      );

    const gripSizeSelect =
      wrapper.querySelector(
        '[data-opt-name="CF Grip Size"] select'
      );

    /* Flex -> Shaft */
    if (
      proxyMap['CF Flex'] &&
      proxyMap['CF Shaft'] &&
      flexSelect
    ) {

      flexSelect.addEventListener(
        'change',
        function() {

          updateFilteredDropdown(
            'CF Flex',
            'CF Shaft'
          );

        }
      );

      updateFilteredDropdown(
        'CF Flex',
        'CF Shaft'
      );
    }

    /* Grip Size -> Grip */
    if (
      proxyMap['CF Grip Size'] &&
      proxyMap['CF Grip'] &&
      gripSizeSelect
    ) {

      gripSizeSelect.addEventListener(
        'change',
        function() {

          updateFilteredDropdown(
            'CF Grip Size',
            'CF Grip'
          );

        }
      );

      updateFilteredDropdown(
        'CF Grip Size',
        'CF Grip'
      );
    }
    
    /*  
    if (
      flexSelect
    ) {

      flexSelect.addEventListener(
        'change',
        function() {

          updateFilteredDropdown(
            'CF Flex',
            'CF Shaft'
          );

        }
      );

      updateFilteredDropdown(
        'CF Flex',
        'CF Shaft'
      );

    }

    if (
      gripSizeSelect
    ) {

      gripSizeSelect.addEventListener(
        'change',
        function() {

          updateFilteredDropdown(
            'CF Grip Size',
            'CF Grip'
          );

        }
      );

      updateFilteredDropdown(
        'CF Grip Size',
        'CF Grip'
      );

    }
    */  

  }

  function initAll() {
    qsa('.go-wrapper[data-product-id]').forEach(function(wrapper) {
      var proxies = buildBlocks(wrapper);
      if (!proxies.length) return;

      injectFormInputs(wrapper, proxies);
      dispatchChange(wrapper, proxies);
      proxies.forEach(function(p) {
        p.onChange(function() { injectFormInputs(wrapper, proxies); dispatchChange(wrapper, proxies); });
      });

      /* Set up Add to Cart button — handles both table and dropdown cases */
      initAddToCart(wrapper, proxies);
      initShopFilters(wrapper, proxies);
    });
  }

  function initSequentialFlow(wrapper) {

    const selects = Array.from(
      wrapper.querySelectorAll(
        '.go-select'
      )
    );

    if (!selects.length) {
      return;
    }

    selects.forEach(function(select, index) {

      if (index === 0) {

        select.disabled = false;
        select.classList.remove(
          'go-select--disabled'
        );

        return;
      }

      select.disabled = true;
      select.classList.add(
        'go-select--disabled'
      );

    });

    selects.forEach(function(select, index) {

      select.addEventListener(
        'change',
        function() {

          const nextSelect =
            selects[index + 1];

          if (!nextSelect) {
            return;
          }

          if (this.value) {

            nextSelect.disabled = false;

            nextSelect.classList.remove(
              'go-select--disabled'
            );

          } else {

            nextSelect.value = '';

            nextSelect.disabled = true;

            nextSelect.classList.add(
              'go-select--disabled'
            );

          }

        }
      );

    });

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initEarlyValidation(); initAll(); });
  } else {
    initEarlyValidation(); initAll();
  }
  document.addEventListener('shopify:section:load', function() {
    qsa('.go-wrapper[data-product-id]').forEach(initInstance);
  });

})();

const mainSection =
    document.querySelector('.main-product-section');

function setPopupState(open) {
    mainSection?.classList.toggle('go-popup-open', open);
}

function openShaftPopup() {
    document.getElementById('shaftPopup').classList.add('show');
    setPopupState(true);
}

function closeShaftPopup() {
    document.getElementById('shaftPopup').classList.remove('show');
    setPopupState(false);
}

function closeGlobalPopup() {
    document.getElementById('go-popup').style.display = 'none';
    setPopupState(false);
}

document.addEventListener('click', function (e) {
    if (e.target.closest('.shaft-info-icon')) {
        e.preventDefault();
        openShaftPopup();
        return;
    }

    if (
        e.target.closest('.shaft-popup-close') ||
        e.target.classList.contains('shaft-popup-overlay')
    ) {
        e.preventDefault();
        closeShaftPopup();
        return;
    }
});

// ESC key closes popup
document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape')
        return;

    closeShaftPopup();
    closeGlobalPopup();
});

document.addEventListener('click',function(e){
    var a=e.target.closest('.go-popup-link');

    if(!a)
       return;

    e.preventDefault();

    var wrapper = document.querySelector('.go-wrapper');

    if (!wrapper)
        return;

    openPopup(
        wrapper,
        a.dataset.option
    );
});

document.addEventListener('click', function (e) {
    if (
        e.target.closest('.go-popup-close') ||
        e.target.classList.contains('go-popup-overlay')
    ) {
        e.preventDefault();
        e.stopPropagation();

        closeGlobalPopup();

        return;
    }
});

function openPopup(wrapper,name){
    var product=
        wrapper.resolvedOptions.find(function(x){
            return x.name===name;
        });

    var master=
        wrapper.globalOptions.find(function(x){
            return x.name===name;
        });

    if(!product || !master)
        return;

    setPopupState(true);

    var html='<div class="go-popup-top-image"><img src="'+window.SHOPIFY_FILES_BASE+'global_options_top.png"></div>';

    if(name==='CF Shaft'){
        html+=`
        <table class="go-popup-table">
        <tr>
        <th>Shafts</th>
        <th>Price</th>
        <th>Flex</th>
        <th>Weight</th>
        <th>Torque</th>
        <th>Ball Flight</th>
        </tr>
        `;
    }

    if(name==='CF Grip'){
        html+=`
        <table class="go-popup-table">
        <tr>
        <th>Grips</th>
        <th>Price</th>
        <th>Material</th>
        <th>Weight</th>
        <th>Core Size</th>
        <th>Grip Shape</th>
        </tr>
        `;
    }

    if(name==='CF Tip Installed'){
        html+=`
        <table class="go-popup-table">
        <tr>
        <th>CF Tip</th>
        <th>Bore</th>
        <th>Driver</th>
        <th>Wood</th>
        <th>Hybrid</th>
        <th>Right Hand</th>
        <th>Left Hand</th>
        <th>Brand</th>
        </tr>
        `;
    }

    product.options.forEach(function(p){
        var m=
        master.options.find(function(x){
            return x.label===p.label;
        });

        if(!m)
            return;

        html+='<tr>';

        html+='<td>';

        html+=p.label;

        if(m.image){
            html+='<br>';

            html+='<img src="'+
            window.SHOPIFY_FILES_BASE+
            m.image+
            '">';
        }

        html+='</td>';

        if(name==='CF Shaft'){
            html+='<td>$'+(p.price_cents/100).toFixed(2)+'</td>';
            html+='<td>'+m.flex+'</td>';
            html+='<td>'+m.weight+'</td>';
            html+='<td>'+m.torque+'</td>';
            html+='<td>'+m.ball_flight+'</td>';
        }

        if(name==='CF Grip'){
            html+='<td>$'+(p.price_cents/100).toFixed(2)+'</td>';
            html+='<td>'+m.material+'</td>';
            html+='<td>'+m.weight+'</td>';
            html+='<td>'+m.core_size+'</td>';
            html+='<td>'+m.grip_shape+'</td>';
        }

        if(name==='CF Tip Installed'){
            html+='<td>'+m.bore+'</td>';
            html+='<td>'+m.driver+'</td>';
            html+='<td>'+m.wood+'</td>';
            html+='<td>'+m.hybrid+'</td>';
            html+='<td>'+m.right_hand+'</td>';
            html+='<td>'+m.left_hand+'</td>';
            html+='<td>'+m.brand+'</td>';
        }

        html+='</tr>';
    });

    html+='</table>';
    
    document.getElementById('go-popup-content').innerHTML=html;
    document.getElementById('go-popup').style.display='block';
}

let notifyData = {};

document.addEventListener('click', function(e){
    const btn = e.target.closest('.go-notify-btn');
    if (!btn) return;

    const wrapper = btn.closest('.go-wrapper');

    notifyData = {

        productId: wrapper.dataset.productId,

        productTitle: wrapper.dataset.productTitle,

        productHandle: wrapper.dataset.productHandle,

        optionGroup: btn.dataset.optionGroup,

        optionLabel: btn.dataset.optionLabel,

        sku: btn.dataset.sku

    };

    const row = btn.closest('tr');

    // If this row already has a form, close it
    const nextRow = row.nextElementSibling;

    if (nextRow && nextRow.classList.contains('go-notify-row')) {
        const form = nextRow.querySelector('.go-notify-form');
        form.classList.remove('show');
        form.addEventListener('transitionend', function handler(e){
            if (e.propertyName !== 'max-height') return;
            nextRow.remove();
            form.removeEventListener('transitionend', handler);
        });
        return;
    }

    // Close any other open form
    document.querySelectorAll('.go-notify-row').forEach(function(r){
        r.remove();
    });

    row.insertAdjacentHTML('afterend', `
        <tr class="go-notify-row">
            <td colspan="3">
                <div class="go-notify-form">
                  <div class="go-notify-content">
                    <div class="go-notify-title">
                        Notify me when this item is back in stock
                    </div>
                    <div class="go-notify-fields">
                        <input
                            type="email"
                            class="go-notify-email"
                            placeholder="Enter your email">
                        <button
                            type="button"
                            class="go-notify-submit">
                            <i class="fa fa-paper-plane"></i>
                        </button>
                    </div>
                    <div class="go-notify-error"></div>
                  </div>  
                </div>
            </td>
        </tr>
    `);

  const newRow = row.nextElementSibling;

  requestAnimationFrame(function(){
    newRow
        .querySelector('.go-notify-form')
        .classList.add('show');
  });  

});

document.addEventListener('click', function(e){
    const btn = e.target.closest('.go-notify-submit');
    if (!btn) return;

    const notifyForm = btn.closest('.go-notify-form');
    const emailInput = notifyForm.querySelector('.go-notify-email');
    const errorBox = notifyForm.querySelector('.go-notify-error');
    const email = emailInput.value.trim();

    // Reset validation
    emailInput.classList.remove('error');
    errorBox.classList.remove('show');
    errorBox.textContent = '';

    // Required validation
    if (email === '') {
        emailInput.classList.add('error');
        errorBox.textContent = 'Email address is required.';
        errorBox.classList.add('show');
        emailInput.focus();
        return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
        emailInput.classList.add('error');
        errorBox.textContent = 'Invalid email address!';
        errorBox.classList.add('show');
        emailInput.focus();
        return;
    }
    subscribeCustomer(btn, email);
});

document.addEventListener('input', function(e){
    if (!e.target.classList.contains('go-notify-email'))
        return;

    e.target.classList.remove('error');

    const errorBox = e.target
        .closest('.go-notify-form')
        .querySelector('.go-notify-error');

    errorBox.classList.remove('show');
    errorBox.textContent = '';
});

function subscribeCustomer(button, email){
    button.disabled = true;
    button.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';

    fetch(window.BackInStockAppUrl + '/api/subscribe.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
            shopify_product_id: notifyData.productId,
            product_title: notifyData.productTitle,
            product_handle: notifyData.productHandle,
            option_group: notifyData.optionGroup,
            option_label: notifyData.optionLabel,
            sku: notifyData.sku,
            customer_email: email
        })
    })
    .then(function(response){
        return response.json();
    })
    .then(function(result){
        button.disabled = false;
        button.innerHTML = '<i class="fa fa-paper-plane"></i>';

        const notifyForm = button.closest('.go-notify-form');
        const notifyContent = button.closest('.go-notify-content');

        if(result.success){
            notifyContent.innerHTML = `
                <div class="go-notify-success">
                    <div class="go-notify-success-icon">
                        <i class="fa fa-check-circle"></i>
                    </div>
                    <div class="go-notify-success-text">
                        ${result.message}
                    </div>
                </div>
            `;

            // Auto close after 3 seconds
            setTimeout(function(){
                notifyForm.classList.remove('show');
                notifyForm.addEventListener('transitionend', function handler(e){
                    if(e.propertyName !== 'max-height') return;
                    const notifyRow = notifyForm.closest('.go-notify-row');
                    if(notifyRow){
                      notifyRow.remove();
                    }
                    notifyForm.removeEventListener('transitionend', handler);
                });
            },3000);
        }else {
            const errorBox = notifyContent.querySelector('.go-notify-error');
            errorBox.textContent = result.message;
            errorBox.classList.add('show');
        }
    })
    .catch(function(){
        button.disabled = false;
        button.innerHTML = '<i class="fa fa-paper-plane"></i>';

        const notifyContent = button.closest('.go-notify-content');
        const errorBox = notifyContent.querySelector('.go-notify-error');

        errorBox.textContent = 'Something went wrong. Please try again.';
        errorBox.classList.add('show');
    });
}